export default __webpack_public_path__ + "static/media/b03.282b6fa5.jpg";